import React, { useState } from "react";
import LayoutProvider from "../../../../providers/LayoutProvider";
import "./style.scss"
import { Link, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import { FiEdit, FiTrash2 } from "react-icons/fi";
import { deleteGroup, getGroups } from "../../../../components/Axios/Axios";
import { setFlagsFromString } from "v8";
import AdminPagesProvider from "../../../../providers/AdminPagesProvider";
import useCustomToast from "../../../../hooks/useCustomToast";
import { Toaster } from "react-hot-toast";
import SpinnerLoader from "../../../../components/SpinnerLoader";

function UserGroupList() {
    const [data,setData]=useState([])
    const [pagination, setPagination] = useState<any>([])
    const [loading,setLoading]=useState(false)
    const navigate = useNavigate()
    const customToast = useCustomToast();

    const handleClick = () => {
        navigate('/admin/user-groups-form');
    };

    const handleDelete = (id:any) => {
      try {
        deleteGroup(id);
        console.log(id)
        fetchData(); 
        customToast("Group deleted successfully", "success")
      } catch (error) {
        customToast("Error deleting group", "error");
        console.error('Error deleting user:', error);
      }
      
    };

    const handleEdit = (id:any) => {
     navigate(`/admin/edit-group/${id}`)
  };

    const columns = [ 
        {
          name: "Name",
          cell: (row: any) => (
            <button onClick={()=>handleEdit(row._id)}  style={{border:"none",background:"none"}}>
              {row?.name}
            </button>
          ),
          sortable: true,
          grow: 3,
          wrap: true,
        },
        {
          name: "No of Permissions",
          selector: (row: any) => row?.perms.length,
          sortable: true,
          grow: 3,
          wrap: true,
        },
        {
          name: "Actions",
          cell: (row: any) => {
            return (
              <div className="d-flex align-items-center gap-4 justify-content-between">
                  <FiEdit
                    className="text-success "
                    style={{
                      cursor: "pointer",
                      fontSize: "1.2em",
                      fontWeight: 600,
                    }}
                    onClick={e=>handleEdit(row._id)}
                  />
                <FiTrash2
                  className="2 text-danger "
                  style={{ cursor: "pointer", fontSize: "1.2em", fontWeight: 600 }}
                  onClick={e=>handleDelete(row._id)}
                />
              </div>
            );
          },
        },
      ];
      const paginationComponentOptions = {
        rowsPerPageText: "Rows Per Page",
        rangeSeparatorText: "of",
        selectAllRowsItem: true,
        styles: {
          background: "red",
        },
      };

        const fetchData = async () => {
          try {
            const response = await getGroups();
            const users = response.data || [];
            const page =response.paginator || [];
            console.log(users.length)
            setData(users)
            setPagination(page)
            console.log("called")
          } catch (error) {
            console.error('Error fetching group data:', error);
          }
        };
    
   

      React.useEffect(() => {
        fetchData();
    }, []);

      function handlePageChange(currentPage:any) {
        // Handle page change here
        // For example, you can navigate to a different URL using react-router-dom
        // or you can fetch data for the new page
       currentPage=currentPage+1;
        // Add your logic here
    }
    
    return (
      <AdminPagesProvider>
        <LayoutProvider>
        {/* {loading === false && <SpinnerLoader />} */}
            <h6 className="dashboard_subheading">Dashboard {">"} Groups List</h6>
            <section
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginBottom:"1%"
                }}
            >
                <h4 className="dashboard_heading">Groups List</h4>
            <div className="d-flex justify-content-end" ><button onClick={() => handleClick()} className="button" >Add Group</button></div>
            </section>
            <Toaster/>
            <DataTable
                columns={columns}
                data={data || []}
                selectableRows
                pagination
                paginationPerPage={pagination.perPage}
                paginationTotalRows={pagination.itemCount}
            //     paginationDefaultPage={pagination.currentPage}
            //     paginationIconPrevious={pagination.prev}
            //    paginationIconNext={pagination.next}
            //    onChangePage={(currentPage) => handlePageChange(currentPage)}
                // onRowClicked={(row) => {
                //     if (user?.role === ROLES.INSTRUCTOR) {
                //         navigate(`/training/request-signatures/approve/${row?._id}`)
                //     }
                // }}
                paginationComponentOptions={paginationComponentOptions}
                customStyles={{
                    rows: {
                        style: {
                            minHeight: "60px",
                            // cursor: user?.role === ROLES.INSTRUCTOR ? "pointer" : "default",
                            "&:nth-child(odd)": {
                                background: "#EFF6FF",
                            },
                        },
                    },
                    headCells: {
                        style: {
                            fontSize: "14px",
                            fontWeight: "bold",
                        },
                    },
                    cells: {
                        style: {
                            fontSize: "14px",
                        },
                    },
                }}            />


            </LayoutProvider>
        </AdminPagesProvider>
    );
}

export default UserGroupList;
